import {
    UPDATE_LOADING_STATUS,
    UPDATE_SELECTED_PROJECT,
    FETCH_SELECTED_PROJECT_MEMBER_LIST,
    FETCH_SELECTED_PROJECT_AVAILABLE_MEMBER_LIST,
    ADD_MEMBER_TO_PROJECT,
    REMOVE_MEMBER_FROM_PROJECT,
    UPDATE_PROJECT_MEMBER_AUTH,
    UPDATE_PROJECT_STATUS,
    UPDATE_PROJECT_DUE,
    UPDATE_LOCATION_LIST,
    UPDATE_ESTATE_LIST,
} from '../ActionTypes'

const INITIAL_STATE = {
    selectedProject: {},
    selectedProjectMemberList: {},
    selectedProjectAvailableMemberList: undefined,
    loadingStatus: {
        isLoading: false,
        tip: ''
    },
    isMemberAdding: false,
    isMemberRemoving: false,
    isMemberChangingAuth: false,
    isProjectStatusUpdating: false,
    locationList: [],
    estateList: []
}

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case UPDATE_LOADING_STATUS:
            return {...state,
                loadingStatus: {
                    isLoading: action.payload.isLoading,
                    tip: action.payload.tip
                }
            }
        case UPDATE_SELECTED_PROJECT:
            return {...state, selectedProject: action.payload }
        case FETCH_SELECTED_PROJECT_MEMBER_LIST:
            return {...state, selectedProjectMemberList: action.payload }
        case FETCH_SELECTED_PROJECT_AVAILABLE_MEMBER_LIST:
            return {...state, selectedProjectAvailableMemberList: action.payload }
        case ADD_MEMBER_TO_PROJECT:
            return {...state, isMemberAdding: action.payload }
        case REMOVE_MEMBER_FROM_PROJECT:
            return {...state, isMemberRemoving: action.payload }
        case UPDATE_PROJECT_MEMBER_AUTH:
            return {...state, isMemberChangingAuth: action.payload }
        case UPDATE_PROJECT_STATUS:
            return {...state, isProjectStatusUpdating: action.payload }
        case UPDATE_PROJECT_DUE:
            return {...state, selectedProject: {...state.selectedProject, due: action.payload } }
        case UPDATE_LOCATION_LIST:
            return {...state, locationList: action.payload }
        case UPDATE_ESTATE_LIST:
            return {...state, estateList: action.payload }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/App/AppReducer.js